import React, { useEffect } from "react";
import ConfidentialiteContentEn from "../components/biggest/cgu/ConfidentialiteContentEn";
import ConfidentialiteContentFr from "../components/biggest/cgu/ConfidentialiteContentFr";
import Footer from "../components/biggest/Footer";
import i18n from "../globalTraduction";
import { smoothScrollUp } from "../services/utils";
import { useStorePageManager } from "../store/PageManage";
export default function ConfidentialitePage() {
  const handleUpdateStorePage = useStorePageManager(
    (state) => state.handleUpdateStorePage
  );
  useEffect(() => {
    handleUpdateStorePage(false);
  }, []);
  useEffect(() => {
    let newTimeout = setTimeout(() => {
      smoothScrollUp(true);
    }, 100);
    return () => {
      clearTimeout(newTimeout);
    };
  }, []);
  const language = i18n.language;
  return (
    <>
      {/* <Header /> */}
      <main>
        {language === "fr" ? (
          <ConfidentialiteContentFr />
        ) : (
          <ConfidentialiteContentEn />
        )}
        <Footer />
      </main>
    </>
  );
}
